export class InvalidVerificationCodeError extends Error {
  constructor() {
    super(`The code is invalid`);
  }
}
